import * as React from 'react';

import useStraightToCheckoutEnrollFlow from 'bundles/enroll-common/components/freemium-flow/hooks/useStraightToCheckoutEnrollFlow';
import ConsumerEnrollButtonNotConfigurable from 'bundles/unified-description-page-common/components/enroll/consumer/ConsumerEnrollButtonNotConfigurable';
import type { EnrollButtonTrackingData } from 'bundles/unified-description-page-common/components/enroll/consumer/EnrollButtonContent';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';
import { getFormattedCourseDataFromConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/utils/getFormattedCourseDataFromConsumerProductPageFieldsFragment';

const ConsumerSpecializationEnrollButtonNotConfigurable = ({
  pageData,
  size,
  onlyShowButton,
  shouldGoStraightToCheckout,
  buttonTrackingData,
}: {
  pageData: ConsumerSpecializationPageFieldsFragment;
  size?: 'small' | 'large';
  buttonTrackingData?: EnrollButtonTrackingData;
  onlyShowButton?: boolean;
  // When true, clicking the button skips the enroll modal and routes the user straight to checkout.
  shouldGoStraightToCheckout?: boolean;
}) => {
  const courses = pageData ? getFormattedCourseDataFromConsumerSpecializationPageFieldsFragment(pageData) : [];
  // straightToCheckoutEnroll needs a course to enter the specialization subscription through.
  const { alternateEnrollFlow, isCheckoutLoading } = useStraightToCheckoutEnrollFlow({
    courseId: courses[0]?.id,
    s12nId: pageData?.id,
  });

  if (!pageData) {
    return null;
  }

  return (
    <ConsumerEnrollButtonNotConfigurable
      courseCount={pageData.courses?.length}
      s12nCourses={courses}
      s12nId={pageData.id}
      alternateEnrollFlow={shouldGoStraightToCheckout ? alternateEnrollFlow : undefined}
      isCheckoutLoading={shouldGoStraightToCheckout ? isCheckoutLoading : undefined}
      s12nProductVariant={pageData.productVariant}
      partnerIds={pageData?.partners?.map(({ id }) => id)}
      name={pageData.name}
      slug={pageData.slug}
      isSpecialization
      onStickyHeader={size === 'small'}
      buttonTrackingData={buttonTrackingData}
      onlyShowButton={onlyShowButton}
    />
  );
};

export default ConsumerSpecializationEnrollButtonNotConfigurable;
